import { tpoCertificationApi } from 'app/services/api';

import { createNamedActions } from 'utils/namedActionTypesProxy';

export const SUB_COMPANY_SIGNUP_CONFIG_ACTION_TYPE = createNamedActions('subCompanySignupConfig', {
  GET: 'GET',
});

// { tpoSignupConfigurationId, name, createdDate } or null — the signup config the
// SubCompany was created under (shown on the Company Profile identity area).
//
// This is enhancement-only provenance context, NOT load-bearing data. Any failure
// to read it — the ApplyForm endpoint not yet deployed, the SubCompany having no
// originating application, a cross-company 403, a transient error — simply means
// "no provenance to show". So we deliberately do NOT wrap this in
// catchAsyncActionError (which re-rejects, surfacing an error toast and tripping
// the dev error overlay); instead we swallow the failure and dispatch a null
// payload, leaving the profile fully usable with the "Created under" line hidden.
export const getSubCompanySignupConfigAction = params => async dispatch => {
  const config = await tpoCertificationApi
    .getSignupConfig(params)
    .then(response => response.data)
    .catch(() => null);

  return dispatch({
    type: SUB_COMPANY_SIGNUP_CONFIG_ACTION_TYPE.GET,
    payload: config,
  });
};
